module.exports = __webpack_public_path__ + "923d2d3b62fca2745722ebe79188daeb.jpg";